import { render, staticRenderFns } from "./DialogAddHonor.vue?vue&type=template&id=01b2df1a&scoped=true"
import script from "./DialogAddHonor.vue?vue&type=script&lang=js"
export * from "./DialogAddHonor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b2df1a",
  null
  
)

export default component.exports